<template>
    <div id="component-checkmark">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150.2 150.2">
            <circle fill="none" stroke="#2cbda8" stroke-width="18" stroke-miterlimit="10" cx="75.1" cy="75.1" r="62.1" class="path circle"></circle>
            <polyline fill="none" stroke="#2cbda8" stroke-width="18" stroke-linecap="round" stroke-miterlimit="10" points="103.2,55.2 61.5,98.8 39.8,77.5 " class="path check"></polyline>
        </svg>
    </div>
</template>

<script>
export default {
    name: "Checkmark",
    components: {
        
    },
    data: () => ({

    }),
    methods: {

    }
}
</script>